import { Text } from "@simplybusiness/mobius";
import type { ReactNode } from "react";

export type TitleProps = {
  children: ReactNode;
};

export const Title = (props: TitleProps) => {
  const { children } = props;

  return (
    <Text className="mobius-footer__heading" variant="small" elementType="h3">
      {children}
    </Text>
  );
};
